export const TOAST_SUCCESS_IDS={
    //general
    'RECORD_SAVED_SUCCESSFULLY':'Registro guardado correctamente',
    'RECORD_UPDATED_SUCCESSFULLY':'Registro actualizado correctamente',
    'RECORD_DELETED_SUCCESSFULLY':'Registro eliminado correctamente',
    'CORRECT_DOWLOAD':'Descarga correctamente',
    'CORRECT_SEARCH':'Búsqueda correctamente',
    'PASSWORD_UPDATED_SUCCESSFULLY':'Contraseña actualizada correctamente',
    //dependecy
    'DEPENDENCY_SUCCESSFULLY_DISABLED':'Dependencia desactivada correctamente',
    //renapo
    'CORRECT_TEST_SAVED':'Test correcto',
    'CORRECT_TEST_FROM_ACTIVE_CONFIGURATION':'Test correcto,configuracion correcta',


    //registro exitoso de invitacion successful registration
    'SUCCESFUL_REGISTRATION':'¡Registro completado exitosamente!'
}

export const TOAST_ERROR_IDS={
    //dependency
    'NO_MATCH_DEPENDENCY_NAME':'El nombre de la dependencia y el nombre que ingresaste no coinciden.',
     //perfil
    'ERROR_CHANGING_THE_PASSWORD':'Error al cambiar la contraseña',
     //general
    'TWO': 'Algún valor ya fue registrado',
    'ERROR_PERFORMING_THIS_ACTION':'Error al realizar esta acción.',
    'SERVER_CONNECTION_ERROR':'Error de conexión con el servidor.',
    'ERROR_TO_DELETE_RECORD':'Error al eliminar el registro',
     //INVITACIONES
     'ERROR_CANCELING_INVITATION':'Error al cancelar la invitación.',
     'ERROR_DOWNLOADING_THE_FILE':'Error al descargar el archivo',
     //ERROR CON LA RENAPO
     'ERROR_CONNECTING_TO_RENAPO':'ERROR_CONNECTING_TO_RENAPO',
     'ERROR_OBTAINING_NAMES':'Error al obtener los nombres de '
}

export const TOAST_INFO_IDS={
    //general
    'ARE_YOU_SURE_WANT_TO_DELETE_THIS':'¿Estás seguro de eliminar ',
    'ARE_YOU_SURE_WANT_TO_DELETE_THIS_RECORD':'¿Estás seguro de eliminar este registro?',
    'NO_DATA_TO_UPDATE':'No actualizaste datos.',
    'ENTER_THE_REQUESTED_INFORNATION':'Ingresa los datos que se te solicitan',

    //Tipos de certificados
    'THE_DATE_MUST_HAVE_AT_LEAST_ONE_VALIDITY_VALUE':'La fecha debe tener al menos un día de vigencia',
    //INVITACIONES
    'INVITATION_SUCCESSFULLY_CANCELLED':'Invitación cancelada exitosamente',
    'ARE_YOU_SURE_YOU_WANT_TO_CANCEL_THIS_INVITATION':'¿Estás seguro de cancelar esta invitación?'
}